import { Component, HostBinding, ViewEncapsulation } from '@angular/core';
import { Menu, MenuService } from '@core';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-topmenu',
  templateUrl: './topmenu.component.html',
  styleUrls: ['./topmenu.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TopmenuComponent {
  @HostBinding('class') class = 'matero-topmenu';

  public environment = environment;

  public menus: Observable<Menu[]>;

  constructor(public menuService: MenuService) {
    this.menus = this.menuService.getFilteredMenu();
  }

  // Delete empty values and rebuild route
  buildRoute(routes: string[]) {
    let route = '';
    routes.forEach(item => {
      if (item && item.trim()) {
        route += `/${item.replace(/^\/+|\/+$/g, '')}`;
      }
    });
    return route;
  }
}
